import { render, staticRenderFns } from "./HistoryWithEmployee.vue?vue&type=template&id=6062b8ca&scoped=true&"
import script from "./HistoryWithEmployee.vue?vue&type=script&lang=js&"
export * from "./HistoryWithEmployee.vue?vue&type=script&lang=js&"
import style0 from "./HistoryWithEmployee.vue?vue&type=style&index=0&id=6062b8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6062b8ca",
  null
  
)

export default component.exports